import React from 'react';
import {
  StructuredTaskField,
  StructuredTaskFieldRow,
  StructuredTaskSection,
} from '../../../../common/components/StructuredTaskDetails';
import { Resource } from '../../../../common/constants/resource';
import { TRLApplicant } from '../../../tasks/types/trl';
import {
  dateToString,
  valueToString,
} from '../../utilities/formattingUtilities';

export const RenderApplicantSection = ({
  applicant,
}: {
  applicant: TRLApplicant;
}) => {
  return (
    <StructuredTaskSection title={Resource.TRL_APPLICANT_SUBTITLE}>
      <StructuredTaskFieldRow>
        <StructuredTaskField
          label={Resource.TRL_APPLICANT_NAME}
          value={valueToString(applicant.name)}
        />
        <StructuredTaskField
          label={Resource.TRL_APPLICANT_BIRTH_DATE}
          value={dateToString(applicant.dob)}
        />
        <StructuredTaskField
          label={Resource.TRL_APPLICANT_SSN}
          value={formatSSN(applicant.ssn)}
        />
      </StructuredTaskFieldRow>
    </StructuredTaskSection>
  );
};

function formatSSN(ssn: string) {
  switch (ssn) {
    case Resource.TRL_APPLICANT_SSN_EXACT_KEY:
      return Resource.TRL_APPLICANT_SSN_EXACT_VALUE;
    default:
      return ssn;
  }
}
